const dummyBarChartData = [
    // 2024 Data
    { year: 2024, month: 1, categoryA: { paid: 30000, pending: 20000 }, categoryB: { paid: 40000, pending: 20000 } },
    { year: 2024, month: 2, categoryA: { paid: 35000, pending: 20000 }, categoryB: { paid: 42000, pending: 20000 } },
    { year: 2024, month: 3, categoryA: { paid: 32000, pending: 20000 }, categoryB: { paid: 38000, pending: 20000 } },
    { year: 2024, month: 4, categoryA: { paid: 38000, pending: 20000 }, categoryB: { paid: 43000, pending: 20000 } },
    { year: 2024, month: 5, categoryA: { paid: 39000, pending: 20000 }, categoryB: { paid: 45000, pending: 20000 } },
    { year: 2024, month: 6, categoryA: { paid: 40000, pending: 20000 }, categoryB: { paid: 46000, pending: 20000 } },
  
    // 2025 Data
    { year: 2025, month: 1, categoryA: { paid: 42000, pending: 20000 }, categoryB: { paid: 48000, pending: 20000 } },
    { year: 2025, month: 2, categoryA: { paid: 43000, pending: 20000 }, categoryB: { paid: 49000, pending: 20000 } },
    { year: 2025, month: 3, categoryA: { paid: 44000, pending: 20000 }, categoryB: { paid: 50000, pending: 20000 } },
    { year: 2025, month: 4, categoryA: { paid: 45000, pending: 20000 }, categoryB: { paid: 51000, pending: 20000 } },
    { year: 2025, month: 5, categoryA: { paid: 46000, pending: 20000 }, categoryB: { paid: 52000, pending: 20000 } },
    { year: 2025, month: 6, categoryA: { paid: 47000, pending: 20000 }, categoryB: { paid: 53000, pending: 20000 } }
  ];
  
  export default dummyBarChartData;
  